import { Grid, Alert, Typography, autocompleteClasses, Box } from "@mui/material"
import Head from "next/head"
import DesktopWrapper from "../../layout/desktop/desktop-wrapper"
import ClubPlanModal from "./club-modal"
import { useEffect, useState } from "react"
import clubServices from "../../../services/club"
import PackageCard from "./package-card"
import { Warning } from "@mui/icons-material"
import { useIsMobile } from "../../../hooks/useIsMobile"
import ModalLoading from "../../common/modal-loading"

const ClubList = () => {
  const [showClubModal, setShowClubModal] = useState(false)
  const [error, setError] = useState(false)
  const [packageList, setPackageList] = useState([])
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [itemSelected, setItemSelected] = useState(0)
  const [errorMessage, setErrorMessage] = useState("")
  const isMobile = useIsMobile()

  const handleDetail = data => {
    setSelectedPlan(data)
  }

  const handlePlanModal = () => {
    setShowClubModal(true)
    if (selectedPlan) {
      setPackageList(prevList =>
        prevList.map(plan =>
          plan.packageId === selectedPlan.packageId
            ? { ...plan, code: selectedPlan.code, expiredDate: selectedPlan.expiredDate }
            : plan
        )
      )
    }
  }

  useEffect(() => {
    setError(false)
    clubServices
      .getPackageList()
      .then(response => {
        if (response?.status === 200) {
          if (!response?.data?.succeed) {
            setError(true)
            setErrorMessage(response.data.message)
          } else {
            setPackageList(response?.data.value)
          }
        }
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {})
  }, [itemSelected])

  return (
    <>
      <Head>
        <title>دریافت تخفیف جت کلاب</title>
      </Head>
      {showClubModal && (
        <ClubPlanModal
          open={showClubModal}
          code={selectedPlan.code}
          expiredDate={selectedPlan.expiredDate}
          setShowClubModal={setShowClubModal}
        />
      )}
      <DesktopWrapper title='جت کلاب'>
        <Typography fontWeight='bold' py={0.7}>
          طرح‌های تخفیف موجود بر اساس مبلغ وام انتخابی شما
        </Typography>
        {packageList.length ? (
          <>
            {!packageList?.length && <ModalLoading open={true} />}
            {!packageList && error && <ClubListError />}
            {packageList && (
              <Box
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "#fdfdfd",
                  mt: 3
                }}
              >
                <Box
                  sx={{
                    width: isMobile ? "100%" : "85%",
                    marginX: "auto",
                    mt: 2
                  }}
                >
                  {!error ? (
                    <Grid container spacing={3}>
                      {packageList.map(item => (
                        <Grid key={item.packageId} item xs={12} md={12}>
                          <PackageCard
                            packageItem={item}
                            handlePlanModal={handlePlanModal}
                            handleDetail={handleDetail}
                            setItemSelected={setItemSelected}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  ) : null}
                </Box>
              </Box>
            )}
          </>
        ) : null}
        {error ? (
          <Grid
            container
            spacing={3}
            sx={{
              width: isMobile ? "100%" : "85%",
              marginX: "auto",
              mt: 2
            }}
          >
            <Alert severity='error'>{errorMessage}</Alert>
          </Grid>
        ) : null}
      </DesktopWrapper>
    </>
  )
}

const ClubListError = () => {
  return (
    <Alert icon={<Warning fontSize='inherit' />} severity='warning'>
      <Typography fontWeight='bold'>خطایی رخ داده است</Typography>
    </Alert>
  )
}

export default ClubList
